module.exports = __webpack_public_path__ + "static/brand9-b596d2e7cdfd3c27c10410b5515fd395.png";